import { h } from "preact";
import { useEffect, useState } from "preact/hooks";
import { useLocation } from "react-router-dom";
import useAxiosCallback from "./useAxiosCallback";


export default function useRestrictedAccess() {

    const { isLoading, fetch } = useAxiosCallback();
    const { pathname } = useLocation();
    const [hasRestrictedAccess, setHasRestrictedAccess] = useState(false);

    useEffect(() => {

        const requestParams = {
            method: "GET",
            headers: {
                "Cache-Control": "no-cache",
                "Pragma": "no-cache", "Expires": "0"
            }
        }

        fetch(pathname, requestParams)
            .then((response) => {
                setHasRestrictedAccess(response.status === 200)
            })
            .catch((error) => {
                setHasRestrictedAccess(false)
            });

    }, [pathname]);


    return { isLoading, hasRestrictedAccess };
}